import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import useColors from "../../api/hooks/useColors";

const LimitsConfirmationDialog = ({
  dialogOpen,
  handleDialogClose,
  limitsReached,
  dialogMessageFirstLine = "",
  dialogMessageSecondLine = "",
  title,
  controlId,
}) => {
  const colors = useColors();

  return (
    <Dialog open={dialogOpen} onClose={() => handleDialogClose(false)}>
      <Box sx={{ width: "480px " }}>
        <DialogTitle>
          <Typography variant="h6">{title}</Typography>
        </DialogTitle>
        <DialogContent>
          <Typography variant="subtitle2" sx={{ color: colors.text_secondary }}>
            {dialogMessageFirstLine}
          </Typography>
          <Typography variant="subtitle2" sx={{ color: colors.text_secondary }}>
            {dialogMessageSecondLine}
          </Typography>
        </DialogContent>
        <DialogActions>
          {limitsReached ? (
            <Button
              onClick={() => handleDialogClose(false)}
              sx={{
                textTransform: "none",
                color: colors.primary_main,
              }}
            >
              Dismiss
            </Button>
          ) : (
            <>
              <Button
                onClick={() => handleDialogClose(false)}
                sx={{
                  textTransform: "none",
                  color: colors.primary_main,
                }}
              >
                Cancel
              </Button>
              <Button
                onClick={() => handleDialogClose(true, controlId)}
                autoFocus
                sx={{
                  textTransform: "none",
                  color: colors.primary_main,
                }}
              >
                Continue
              </Button>
            </>
          )}
        </DialogActions>
      </Box>
    </Dialog>
  );
};

export default LimitsConfirmationDialog;
